import DocLink from './components/DocLink'
import DocCustomUrl from './components/DocCustomUrl'
import DocRowImage from './components/DocRowImage'
import DocLabel from './components/DocLabel'
import DocHeaderLabel from './components/DocHeaderLabel'
import DocStatus from './components/DocStatus'
import JODocStatus from './components/JODocStatus'
import DocStatusAction from './components/DocStatusAction'
import DocTaskStatus from './components/DocTaskStatus'
import DocPriority from './components/DocPriority'
import DocLabelWithSHEditor from './components/DocLabelWithSHEditor'
import DocAddChoice from './components/DocAddChoice'
import DocEditChoice from './components/DocEditChoice'
import DocItemGridDesignLabel from './components/DocItemGridDesignLabel'

import DocEditAction from './components/DocEditAction'

import ItemGridSIHwfc from "../../item/item/components/ItemGridSIHwfc";
import InvGridItemH from "../../inv/components/InvGridItemH";
import InvGridItemD from "../../inv/components/InvGridItemD";

import InvSOGridItemH from "../../inv/components/InvSOGridItemH";
import InvSOGridItemD from "../../inv/components/InvSOGridItemD";

import InvGridItemWPH from "../../inv/components/InvGridItemWPH";
import InvGridItemWPD from "../../inv/components/InvGridItemWPD";

import InvRouteItemD from "../../inv/components/InvRouteItemD";
import InvRouteItemH from "../../inv/components/InvRouteItemH";

import InvGridItemImageD from "../../inv/components/InvGridItemImageD";
import InvGridItemMatInH from "../../inv/components/InvGridItemMatInH";
import InvGridItemMatInD from "../../inv/components/InvGridItemMatInD";
import InvGridItemMatOutH from "../../inv/components/InvGridItemMatOutH";
import InvGridItemMatOutD from "../../inv/components/InvGridItemMatOutD";
import InvGridItemMatRetH from "../../inv/components/InvGridItemMatRetH";
import InvGridItemMatRetD from "../../inv/components/InvGridItemMatRetD";
import ProdGridCreateSO from "../../project/production/order/components/ProdGridCreateSO";
import InvRouteEditorSH from "../../inv/components/InvRouteEditorSH";

import StoreItemH from "../../storage/components/StoreItemH";
import StoreItemD from "../../storage/components/StoreItemD";

import ProfileShorthand from "../../profile/components/ProfileShorthand";
import CategoryMasterSH from "../../system/category/components/CategoryMasterSH";
import CategoryDetailSH from "../../system/category/components/CategoryDetailSH"
import BudgetSH from "../../account/budget/Components/BudgetSH";
import ItemShorthand from '../../item/item/components/ItemShorthand';

import cmnViewMap from '../Index';
import systemViewMap from '../../system/Index';
import ProdGridInfoD from '../../project/production/order/components/ProdGridInfoD'
import BomGridItemH from '../../item/bom/components/BomGridItemH'
import BomGridItemD from '../../item/bom/components/BomGridItemD'
import QCGridItemD from '../../qualityCheck/components/QCGridItemD'
import QCGridItemH from '../../qualityCheck/components/QCGridItemH'
import DocQCStatus from './components/DocQCStatus'
import InvGridItemPOH from '../../inv/components/InvGridItemPOH'
import InvGridItemPOD from '../../inv/components/InvGridItemPOD'
import DocTwoColumn from './components/DocTwoColumn'
import DocLinkWithSHEditor from './components/DocLinkWithSHEditor'
import VoucherGridItemH from '../../account/voucher/components/VoucherGridItemH'
import VoucherGridItemD from '../../account/voucher/components/VoucherGridItemD'

//Make sure this only contains table columns component
const colViewMap = {
    "vCMNGridDocLink" : DocLink,
    "vCMNGridUrl" : DocCustomUrl,
    "vCMNRowImage" : DocRowImage,
    "vCMNGridLabel" : DocLabel,
    "vCMNGridValPerPair" : DocLabel,
    "vCMNGridHeaderLabel" : DocHeaderLabel,
    "vCMNGridPriority":DocPriority,
    "vCMNGridStatus":DocStatus,
    "vJOStatus":JODocStatus,
    "vCMNGridProcessFlowAction":DocStatusAction,
    "vCMNGridTaskStatus":DocTaskStatus,
    "vItemGridDesignLabel": DocItemGridDesignLabel,
    "vCMNQCGridStatus":DocQCStatus,

    "vCMNGridEditAction":DocEditAction,
    "vCMNGridLabelWithSHEditor":DocLabelWithSHEditor,
    "vCMNGridDocLinkWithSHEditor":DocLinkWithSHEditor,
    "vCMNGridTwoColumn" : DocTwoColumn,
    
    "vCatGridAddChoice":DocAddChoice,
    "vCatGridEditChoice":DocEditChoice,
    "vCatMasterSH": CategoryMasterSH,
    "vCatDetailSH": CategoryDetailSH,
    "vProShorthand":ProfileShorthand,
    "vItemShorthand": ItemShorthand,
    "vBudgetSH":BudgetSH,

    "vProdGridInfoD":ProdGridInfoD,

    "vItemGridSIHwfc":ItemGridSIHwfc,

    "vINVGridItemH": InvGridItemH,
    "vINVGridItemD": InvGridItemD,

    "vINVSOGridItemH": InvSOGridItemH,
    "vINVSOGridItemD": InvSOGridItemD,

    "vINVGridItemPOH": InvGridItemPOH,
    "vINVGridItemPOD": InvGridItemPOD,

    "vInvGridItemWPH": InvGridItemWPH,
    "vInvGridItemWPD": InvGridItemWPD,

    "vInvRouteItemD": InvRouteItemD,
    "vInvRouteItemH": InvRouteItemH,

    "vINVGridItemImageD":InvGridItemImageD,

    "vINVGridItemMatInH": InvGridItemMatInH,
    "vINVGridItemMatInD" : InvGridItemMatInD,
    "vINVGridItemMatOutH": InvGridItemMatOutH,
    "vINVGridItemMatOutD" : InvGridItemMatOutD,
    "vINVGridItemMatRetH": InvGridItemMatRetH,
    "vINVGridItemMatRetD" : InvGridItemMatRetD,
    "vProdGridCreateSO":ProdGridCreateSO,
    "vInvRouteEditor":InvRouteEditorSH,

    "vStoreItemH":StoreItemH,
    "vStoreItemD":StoreItemD,

    "vBomGridItemH": BomGridItemH,
    "vBomGridItemD": BomGridItemD,

    "vQCGridItemH":QCGridItemH,
    "vQCGridItemD":QCGridItemD,

    "vVoucherGridItemH": VoucherGridItemH,
    "vVoucherGridItemD": VoucherGridItemD,

    ...cmnViewMap,
    ...systemViewMap
}

export default colViewMap;
